import type {RUnit, Padding} from './types';
import type {Rectangle} from 'pixi.js';

export function calcResponsiveUnits(from: number, val: RUnit): number {
    if (isPercentage(val)) {
        return (parsePercentage(val) / 100) * from;
    }

    return parsePixels(val);
}

export function parsePercentage(val: RUnit): number {
    return Number(val.slice(0, -1));
}

export function parsePixels(val: RUnit): number {
    if (val === '0') {
        return 0;
    }

    return Number(val.slice(0, -2));
}

export function isPercentage(val: RUnit): boolean {
    return val.slice(-1) === '%';
}

export function calcPaddingToPixiRectangle(padding: Padding, context: Rectangle, result: Rectangle): void {
    const top = padding[0];
    let right = padding[0];
    let bottom = padding[0];
    let left = padding[0];

    if (padding.length === 2) {
        left = padding[1];
        right = padding[1];
    }

    if (padding.length === 4) {
        right = padding[1];
        bottom = padding[2];
        left = padding[3];
    }

    result.x = calcResponsiveUnits(context.width, left);
    result.y = calcResponsiveUnits(context.height, top);
    result.width = calcResponsiveUnits(context.width, right) + result.x;
    result.height = calcResponsiveUnits(context.height, bottom) + result.y;
}